module.exports = __webpack_public_path__ + "img/QRIS-GENESIS-REVISI.51f50b81.jpg";